const local = '_PROVIDER_SETOR_FOLLOWAIR_'


var update = false

export default {
	methods: {
		_GET_SETOR: function (callback) {
			this._httpGet('/Setor/get', function (retorno) {
				if (retorno._request && retorno._status) {
					callback(retorno.lista.length > 0 ? retorno.lista : null)
				} else {
					callback(null)
				}
			})
		},

		_providerSetorUpdate: function () {
			//console.log("update classificao")
			// ESTADOS
			this._GET_SETOR(function (lista) {
				if (lista != null) {
					var string = JSON.stringify(lista)
					sessionStorage.setItem(local, string)
				}
			})
		},

		_providerSetor: function (callback) {
			if (!update) {
				update = true
				this._GET_SETOR(function (lista) {
					if (lista != null) {
						var string = JSON.stringify(lista)
						sessionStorage.setItem(local, string)
						callback(lista)
					} else {
						callback([])
					}
				})
			} else {
				if (sessionStorage.getItem(local) != null) {
					callback(JSON.parse(sessionStorage.getItem(local)))
				} else {
					this._GET_SETOR(function (lista) {
						if (lista != null) {
							var string = JSON.stringify(lista)
							sessionStorage.setItem(local, string)
							callback(lista)
						} else {
							callback([])
						}
					})
				}
			}			
		}
	}
}